import { render, staticRenderFns } from "./OrderCustomerSells.vue?vue&type=template&id=48b3637c"
import script from "./OrderCustomerSells.vue?vue&type=script&lang=ts"
export * from "./OrderCustomerSells.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports